import React from 'react';
import { motion } from 'framer-motion';

const LegalNotice = () => {
  return (
    <div className="bg-white py-20">
      <div className="container mx-auto px-4 md:px-8 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-3xl md:text-4xl font-medium mb-8 text-gray-900">Mentions légales</h1>
          
          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="mb-6">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">1. Informations légales</h2>
            <p>
              Le site web <strong>aiko.fr</strong> est édité par :
            </p>
            <p className="mb-4">
              <strong>Aiko</strong><br />
              Société par actions simplifiée (SAS)<br />
              Capital social : 10 000 €<br />
              Siège social : 123 Avenue de la République, 75011 Paris, France<br />
              SIRET : 123 456 789 00012<br />
              RCS Paris B 123 456 789<br />
              N° TVA Intracommunautaire : FR 12 123456789<br />
              Directeur de la publication : Jean Dupont
            </p>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">2. Hébergement</h2>
            <p className="mb-6">
              Ce site est hébergé par :<br />
              <strong>OVH SAS</strong><br />
              2 rue Kellermann<br />
              59100 Roubaix, France<br />
              Téléphone : +33 9 72 10 10 10
            </p>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">3. Propriété intellectuelle</h2>
            <p className="mb-6">
              L'ensemble des éléments constituant ce site (textes, graphismes, logiciels, photographies, images, vidéos, sons, plans, logos, marques, etc.) 
              est la propriété exclusive d'Aiko ou de ses partenaires. Ces éléments sont protégés par les lois françaises et internationales relatives à la 
              propriété intellectuelle.
            </p>
            <p className="mb-6">
              Toute reproduction, représentation, modification, publication, adaptation ou exploitation de tout ou partie des éléments du site, quel que soit 
              le moyen ou le procédé utilisé, est interdite sans autorisation préalable écrite d'Aiko.
            </p>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">4. Liens hypertextes</h2>
            <p className="mb-6">
              Le site peut contenir des liens hypertextes vers d'autres sites internet. Aiko n'exerce aucun contrôle sur ces sites et ne peut être tenu 
              responsable de leur contenu ou de leur politique de confidentialité.
            </p>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">5. Limitation de responsabilité</h2>
            <p className="mb-6">
              Aiko s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur son site. Toutefois, Aiko ne peut garantir l'exactitude, 
              la précision ou l'exhaustivité des informations mises à disposition sur ce site. En conséquence, Aiko décline toute responsabilité pour toute 
              imprécision, inexactitude ou omission portant sur des informations disponibles sur ce site.
            </p>
            <p className="mb-6">
              Aiko se réserve le droit de modifier le contenu de ce site à tout moment et sans préavis.
            </p>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">6. Droit applicable et juridiction compétente</h2>
            <p className="mb-6">
              Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.
            </p>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">7. Nous contacter</h2>
            <p className="mb-6">
              Pour toute question concernant ces mentions légales, vous pouvez nous contacter à :<br />
              <a href="mailto:contact@aiko.fr" className="text-indigo-600 hover:text-indigo-800">contact@aiko.fr</a><br />
              Téléphone : +33 1 23 45 67 89
            </p>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">8. Médiation de la consommation</h2>
            <p className="mb-6">
              Conformément aux dispositions du Code de la consommation concernant le règlement amiable des litiges, Aiko adhère au Service du Médiateur 
              du e-commerce de la FEVAD (Fédération du e-commerce et de la vente à distance). Après démarche préalable écrite des consommateurs vis-à-vis 
              d'Aiko, le Service du Médiateur peut être saisi pour tout litige de consommation dont le règlement n'aurait pas abouti.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LegalNotice;
